import type { FontKey } from './theme';

/**
 * Tenant fonts are downloaded only when a tenant uses them (code-split CSS),
 * so the default bundle keeps a single font family.
 */
const loaders: Record<Exclude<FontKey, 'google-sans-flex'>, () => Promise<unknown>> = {
  inter: () => import('@fontsource-variable/inter'),
  nunito: () => import('@fontsource-variable/nunito'),
  'roboto-slab': () => import('@fontsource-variable/roboto-slab'),
};

export async function loadFont(font: FontKey | null | undefined): Promise<void> {
  if (!font || font === 'google-sans-flex') return;
  try {
    await loaders[font]();
  } catch (error) {
    // The fallback stack still renders; a missing font must never block the app.
    console.warn('[theme] Could not load font', font, error);
  }
}
